<template>
  <v-container>
    <v-card>
      <v-card-title>ລາຍງານ AR ຕາມວັນທີ (ມີຕົວກັ່ນຕອງ)</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-menu
              v-model="asOfDateMenu"
              :close-on-content-click="false"
              max-width="290"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="asOfDate"
                  label="ວັນທີ (as-of)"
                  prepend-icon="mdi-calendar"
                  readonly
                  :error-messages="fieldErrors.as_of_date"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="asOfDate"
                @input="asOfDateMenu = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="8"
          >
            <v-btn-toggle
              v-model="segment"
              mandatory
            >
              <v-btn value="residential">
                ຄົວເຮືອນ
              </v-btn>
              <v-btn value="commercial">
                ຫົວໜ່ວຍທຸລະກິດ
              </v-btn>
              <v-btn value="both">
                ທັງໝົດ
              </v-btn>
            </v-btn-toggle>
            <div
              v-if="fieldErrors.segment && fieldErrors.segment.length"
              class="v-messages theme--light error--text mt-1"
            >
              {{ fieldErrors.segment[0] }}
            </div>
          </v-col>
        </v-row>

        <v-divider class="my-4" />
        <div class="text-subtitle-2 mb-2">
          ຕົວກັ່ນຕອງ (ທາງເລືອກ)
        </div>

        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-menu
              v-model="billFromMenu"
              :close-on-content-click="false"
              max-width="290"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="billCreatedFrom"
                  label="ວັນທີ່ປ້ອນບິນ (ຕັ້ງແຕ່)"
                  hint="ວັນທີ່ບິນຖືກບັນທຶກເຂົ້າລະບົບ — ບໍ່ແມ່ນເດືອນບິນ"
                  persistent-hint
                  prepend-icon="mdi-calendar-import"
                  readonly
                  clearable
                  :error-messages="fieldErrors.bill_created_from"
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="billCreatedFrom = null"
                />
              </template>
              <v-date-picker
                v-model="billCreatedFrom"
                :max="todayIso"
                @input="billFromMenu = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-menu
              v-model="billToMenu"
              :close-on-content-click="false"
              max-width="290"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="billCreatedTo"
                  label="ວັນທີ່ປ້ອນບິນ (ຮອດ)"
                  prepend-icon="mdi-calendar-export"
                  readonly
                  clearable
                  :error-messages="billToErrors"
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="billCreatedTo = null"
                />
              </template>
              <v-date-picker
                v-model="billCreatedTo"
                :min="billCreatedFrom || undefined"
                :max="todayIso"
                @input="billToMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-autocomplete
              v-model="districtIds"
              :items="districts"
              :loading="loadingDistricts"
              label="ເມືອງ"
              item-text="name"
              item-value="id"
              multiple
              chips
              small-chips
              deletable-chips
              clearable
              outlined
              dense
              :error-messages="fieldErrors.district_ids"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-autocomplete
              v-model="villageIds"
              :items="villages"
              :loading="loadingVillages"
              :disabled="!districtIds.length"
              :label="villageIds.length ? 'ບ້ານ (ໃຊ້ແທນຕົວກັ່ນຕອງເມືອງ)' : 'ບ້ານ'"
              :hint="villageIds.length
                ? 'ເມື່ອເລືອກບ້ານ, ການກັ່ນຕອງເມືອງຈະຖືກຂ້າມ'
                : (districtIds.length ? '' : 'ເລືອກເມືອງກ່ອນ')"
              persistent-hint
              item-text="name"
              item-value="id"
              multiple
              chips
              small-chips
              deletable-chips
              clearable
              outlined
              dense
              :error-messages="fieldErrors.village_ids"
            />
          </v-col>
        </v-row>

        <v-btn
          color="primary"
          :loading="submitting"
          :disabled="!canSubmit"
          @click="onExport"
        >
          Export Excel
        </v-btn>
      </v-card-text>
    </v-card>

    <v-card class="mt-4">
      <v-card-title>
        ບົດລາຍງານທີ່ມີຢູ່ແລ້ວ
        <v-spacer />
        <v-btn
          v-if="selected.length"
          color="error"
          class="mr-2"
          small
          :loading="deleting"
          @click="confirmDelete = true"
        >
          <v-icon
            left
            small
          >
            mdi-delete
          </v-icon>
          ລຶບທີ່ເລືອກ ({{ selected.length }})
        </v-btn>
        <v-btn
          icon
          :loading="loadingRecent"
          title="ໂຫຼດຄືນ"
          @click="fetchRecent"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="allExports"
        :loading="loadingRecent"
        :item-class="rowClass"
        no-data-text="ຍັງບໍ່ມີບົດລາຍງານ"
        :items-per-page="10"
        item-key="id"
        show-select
        dense
      >
        <template #[`item.data-table-select`]="{ isSelected, select, item }">
          <v-simple-checkbox
            :value="isSelected"
            :disabled="!isDeletable(item)"
            :ripple="false"
            @input="select($event)"
          />
        </template>
        <template #[`item.params.as_of_date`]="{ item }">
          {{ item.params && item.params.as_of_date }}
        </template>
        <template #[`item.params.segment`]="{ item }">
          {{ segmentLabel(item.params && item.params.segment) }}
        </template>
        <template #[`item.filters_summary`]="{ item }">
          <span
            v-if="filtersSummary(item.params)"
            :title="filtersTooltip(item.params)"
          >
            {{ filtersSummary(item.params) }}
          </span>
          <span
            v-else
            class="text--disabled"
          >ບໍ່ມີ</span>
        </template>
        <template #[`item.status`]="{ item }">
          <v-chip
            x-small
            :color="statusColor(item.status)"
            text-color="white"
          >
            {{ statusLabel(item.status) }}
          </v-chip>
        </template>
        <template #[`item.row_count`]="{ item }">
          {{ item.row_count != null ? item.row_count.toLocaleString() : '-' }}
        </template>
        <template #[`item.file_size`]="{ item }">
          {{ formatSize(item.file_size) }}
        </template>
        <template #[`item.finished_at`]="{ item }">
          {{ formatDateTime(item.finished_at) }}
        </template>
        <template #[`item.actions`]="{ item }">
          <v-progress-circular
            v-if="isInProgress(item)"
            indeterminate
            size="20"
            width="2"
            color="primary"
            title="ກຳລັງສ້າງ..."
          />
          <v-btn
            v-else
            icon
            :href="item.download_url"
            :disabled="!item.download_url"
            target="_blank"
            title="ດາວໂຫລດ"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="confirmDelete"
      max-width="400"
      persistent
    >
      <v-card>
        <v-card-title>ຢືນຢັນການລຶບ</v-card-title>
        <v-card-text>
          ທ່ານຕ້ອງການລຶບ {{ selected.length }} ບົດລາຍງານ ບໍ່?
          ຂໍ້ມູນທີ່ລຶບແລ້ວຈະບໍ່ສາມາດກູ້ຄືນໄດ້.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="deleting"
            @click="confirmDelete = false"
          >
            ຍົກເລີກ
          </v-btn>
          <v-btn
            color="error"
            :loading="deleting"
            @click="deleteSelected"
          >
            ລຶບ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmExport"
      max-width="480"
      persistent
    >
      <v-card>
        <v-card-title>ຢືນຢັນການສົ່ງອອກຊ້ຳ</v-card-title>
        <v-card-text>
          ມີບົດລາຍງານທີ່ໃຊ້ຕົວກັ່ນຕອງດຽວກັນຢູ່ແລ້ວ.
          ທ່ານຕ້ອງການ export ອີກຄັ້ງບໍ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="submitting"
            @click="confirmExport = false"
          >
            ຍົກເລີກ
          </v-btn>
          <v-btn
            color="primary"
            :loading="submitting"
            @click="runExport"
          >
            ສົ່ງອອກ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

const EXPORT_TYPE = 'ar_as_of_date_filtered';

function normalizeIdList(list) {
  if (!Array.isArray(list) || !list.length) return null;
  return [...list].map((x) => Number(x)).sort((a, b) => a - b);
}

function paramsKey(p) {
  if (!p) return '';
  return JSON.stringify({
    as_of_date: p.as_of_date || null,
    segment: p.segment || null,
    bill_created_from: p.bill_created_from || null,
    bill_created_to: p.bill_created_to || null,
    district_ids: normalizeIdList(p.district_ids),
    village_ids: normalizeIdList(p.village_ids),
  });
}

export default {
  name: 'ArAsOfDateFiltered',
  data() {
    const today = new Date();
    const firstOfMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-01`;
    const pad = (n) => String(n).padStart(2, '0');
    const todayIso = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    return {
      asOfDate: firstOfMonth,
      segment: 'residential',
      billCreatedFrom: null,
      billCreatedTo: null,
      districtIds: [],
      villageIds: [],
      districts: [],
      villages: [],
      loadingDistricts: false,
      loadingVillages: false,
      asOfDateMenu: false,
      billFromMenu: false,
      billToMenu: false,
      submitting: false,
      recentExports: [],
      loadingRecent: false,
      selected: [],
      confirmDelete: false,
      confirmExport: false,
      deleting: false,
      fieldErrors: {},
      todayIso,
      headers: [
        { text: 'ວັນທີ (as-of)', value: 'params.as_of_date', sortable: false },
        { text: 'ປະເພດ', value: 'params.segment', sortable: false },
        { text: 'ຕົວກັ່ນຕອງ', value: 'filters_summary', sortable: false },
        { text: 'ສະຖານະ', value: 'status', sortable: false },
        {
          text: 'ຈຳນວນແຖວ', value: 'row_count', align: 'end', sortable: false,
        },
        {
          text: 'ຂະໜາດ', value: 'file_size', align: 'end', sortable: false,
        },
        { text: 'ເວລາສຳເລັດ', value: 'finished_at', sortable: false },
        { text: 'ຜູ້ສ້າງ', value: 'generator_name', sortable: false },
        {
          text: '', value: 'actions', sortable: false, align: 'end',
        },
      ],
    };
  },
  computed: {
    ...mapState('exports', ['jobs']),
    allExports() {
      const vuexJobs = Object.values(this.jobs || {})
        .filter((j) => j && j.type === EXPORT_TYPE);
      const vuexIds = new Set(vuexJobs.map((j) => j.id));
      const merged = [
        ...vuexJobs,
        ...this.recentExports.filter((j) => !vuexIds.has(j.id)),
      ];
      merged.sort((a, b) => (b.id || 0) - (a.id || 0));
      return merged;
    },
    currentParamsKey() {
      return paramsKey({
        as_of_date: this.asOfDate,
        segment: this.segment,
        bill_created_from: this.billCreatedFrom,
        bill_created_to: this.billCreatedTo,
        district_ids: this.districtIds,
        village_ids: this.villageIds,
      });
    },
    billToErrors() {
      const msgs = [...(this.fieldErrors.bill_created_to || [])];
      if (
        this.billCreatedFrom
        && this.billCreatedTo
        && this.billCreatedTo < this.billCreatedFrom
      ) {
        msgs.push('ວັນທີ "ຮອດ" ຕ້ອງບໍ່ກ່ອນ "ຕັ້ງແຕ່"');
      }
      return msgs;
    },
    canSubmit() {
      if (!this.asOfDate || !this.segment) return false;
      if (
        this.billCreatedFrom
        && this.billCreatedTo
        && this.billCreatedTo < this.billCreatedFrom
      ) return false;
      return true;
    },
  },
  watch: {
    jobs: {
      deep: true,
      handler(newJobs) {
        const hasReady = Object.values(newJobs).some(
          (j) => j && j.type === EXPORT_TYPE && j.status === 'ready',
        );
        if (hasReady) this.fetchRecent();
      },
    },
    async districtIds(newIds, oldIds) {
      this.clearFieldError('district_ids');
      if (!newIds.length) {
        this.villages = [];
        this.villageIds = [];
        return;
      }
      const added = newIds.filter((id) => !oldIds.includes(id));
      const removed = oldIds.filter((id) => !newIds.includes(id));
      if (added.length) await this.fetchVillagesForDistricts(added);
      if (removed.length) {
        const removedSet = new Set(removed);
        this.villages = this.villages.filter((v) => !removedSet.has(v.district_id));
        const remainingIds = new Set(this.villages.map((v) => v.id));
        this.villageIds = this.villageIds.filter((id) => remainingIds.has(id));
      }
    },
    asOfDate() { this.clearFieldError('as_of_date'); },
    segment() { this.clearFieldError('segment'); },
    billCreatedFrom() { this.clearFieldError('bill_created_from'); },
    billCreatedTo() { this.clearFieldError('bill_created_to'); },
    villageIds() { this.clearFieldError('village_ids'); },
  },
  mounted() {
    this.fetchRecent();
    this.fetchDistricts();
  },
  methods: {
    async fetchDistricts() {
      this.loadingDistricts = true;
      try {
        const res = await this.$axios.get('info/district', {
          params: { province_id: 1 },
        });
        this.districts = (res.data && res.data.data) || [];
      } catch (_) {
        this.districts = [];
      } finally {
        this.loadingDistricts = false;
      }
    },
    async fetchVillagesForDistricts(districtIds) {
      this.loadingVillages = true;
      try {
        const results = await Promise.all(
          districtIds.map((id) => this.$axios
            .get(`info/district/${id}/village`)
            .then((res) => ((res.data && res.data.data) || []).map((v) => ({
              ...v,
              district_id: v.district_id != null ? v.district_id : id,
            })))
            .catch(() => [])),
        );
        const existingIds = new Set(this.villages.map((v) => v.id));
        const merged = [...this.villages];
        for (const list of results) {
          for (const v of list) {
            if (!existingIds.has(v.id)) {
              merged.push(v);
              existingIds.add(v.id);
            }
          }
        }
        this.villages = merged;
      } finally {
        this.loadingVillages = false;
      }
    },
    clearFieldError(key) {
      if (!this.fieldErrors[key]) return;
      const next = { ...this.fieldErrors };
      delete next[key];
      this.fieldErrors = next;
    },
    buildParams() {
      const p = {
        as_of_date: this.asOfDate,
        segment: this.segment,
      };
      if (this.billCreatedFrom) p.bill_created_from = this.billCreatedFrom;
      if (this.billCreatedTo) p.bill_created_to = this.billCreatedTo;
      if (this.districtIds.length) p.district_ids = [...this.districtIds];
      if (this.villageIds.length) p.village_ids = [...this.villageIds];
      return p;
    },
    async onExport() {
      if (!this.canSubmit) return;
      this.fieldErrors = {};
      const key = this.currentParamsKey;
      const duplicate = this.recentExports.some((j) => paramsKey(j.params) === key);
      if (duplicate) {
        this.confirmExport = true;
        return;
      }
      await this.runExport();
    },
    async runExport() {
      this.confirmExport = false;
      this.submitting = true;
      try {
        await this.$store.dispatch('exports/create', {
          type: EXPORT_TYPE,
          params: this.buildParams(),
        });
      } catch (e) {
        const res = e && e.response;
        if (res && res.status === 422 && res.data && res.data.errors) {
          this.fieldErrors = this.groupLaravelErrors(res.data.errors);
        } else {
          const msg = (res && res.data && res.data.message) || 'Network error';
          this.$store.commit('Toast_State', {
            value: true,
            color: 'error',
            msg,
          });
        }
      } finally {
        this.submitting = false;
      }
    },
    groupLaravelErrors(errors) {
      // Laravel returns nested-array errors keyed like 'district_ids.0'.
      // Roll those up under the parent field name so we can show them
      // on the v-autocomplete/v-text-field directly.
      const out = {};
      for (const [key, msgs] of Object.entries(errors)) {
        const root = key.split('.')[0];
        if (!out[root]) out[root] = [];
        for (const m of msgs) {
          if (!out[root].includes(m)) out[root].push(m);
        }
      }
      return out;
    },
    async fetchRecent() {
      this.loadingRecent = true;
      try {
        const res = await this.$axios.get('v2/export-jobs', {
          params: {
            type: EXPORT_TYPE,
            status: 'queued,running,ready',
            limit: 20,
          },
        });
        this.recentExports = (res.data && res.data.data) || [];
      } catch (_) {
        this.recentExports = [];
      } finally {
        this.loadingRecent = false;
      }
    },
    async deleteSelected() {
      this.deleting = true;
      const ids = this.selected.map((j) => j.id);
      try {
        await Promise.all(
          ids.map((id) => this.$axios.delete(`v2/export-jobs/${id}`)),
        );
        ids.forEach((id) => this.$store.dispatch('exports/dismiss', id));
        this.selected = [];
        this.confirmDelete = false;
        await this.fetchRecent();
      } catch (_) {
        this.confirmDelete = false;
      } finally {
        this.deleting = false;
      }
    },
    isInProgress(item) {
      return item.status === 'queued' || item.status === 'running';
    },
    isDeletable(item) {
      return item.status === 'ready' || item.status === 'failed';
    },
    segmentLabel(seg) {
      if (seg === 'residential') return 'ຄົວເຮືອນ';
      if (seg === 'commercial') return 'ຫົວໜ່ວຍທຸລະກິດ';
      if (seg === 'both') return 'ທັງໝົດ';
      return seg || '-';
    },
    statusLabel(status) {
      const map = {
        queued: 'ກຳລັງຈັດຄິວ',
        running: 'ກຳລັງສ້າງ',
        ready: 'ພ້ອມ',
        failed: 'ຜິດພາດ',
      };
      return map[status] || status || '-';
    },
    statusColor(status) {
      if (status === 'ready') return 'success';
      if (status === 'failed') return 'error';
      if (status === 'running') return 'primary';
      return 'grey';
    },
    formatSize(bytes) {
      if (bytes == null) return '-';
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    },
    formatDateTime(iso) {
      if (!iso) return '-';
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return iso;
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    filtersSummary(params) {
      if (!params) return '';
      const parts = [];
      if (params.village_ids && params.village_ids.length) {
        parts.push(`${params.village_ids.length} ບ້ານ`);
      } else if (params.district_ids && params.district_ids.length) {
        parts.push(`${params.district_ids.length} ເມືອງ`);
      }
      if (params.bill_created_from || params.bill_created_to) {
        const from = params.bill_created_from || '…';
        const to = params.bill_created_to || '…';
        parts.push(`${from} → ${to}`);
      }
      return parts.join(' · ');
    },
    filtersTooltip(params) {
      if (!params) return '';
      const lines = [];
      if (params.district_ids && params.district_ids.length) {
        lines.push(`ເມືອງ: ${params.district_ids.join(', ')}`);
      }
      if (params.village_ids && params.village_ids.length) {
        lines.push(`ບ້ານ: ${params.village_ids.join(', ')}`);
      }
      if (params.bill_created_from) lines.push(`ຕັ້ງແຕ່: ${params.bill_created_from}`);
      if (params.bill_created_to) lines.push(`ຮອດ: ${params.bill_created_to}`);
      return lines.join('\n');
    },
    rowClass(item) {
      return paramsKey(item.params) === this.currentParamsKey
        ? 'match-current-form'
        : '';
    },
  },
};
</script>

<style scoped>
.match-current-form {
  background-color: rgba(76, 175, 80, 0.12);
}
</style>
